import React, { useState } from "react";
import styles from "./Intro.module.scss";
import intro1 from "../../Assets/img/introOne.svg";
import intro2 from "../../Assets/img/introTwo.svg";
import intro3 from "../../Assets/img/introThree.svg";
import arrow from "../../Assets/img/introArrow.svg";
import login from "../../Assets/img/introLoginPic.svg";
import register from "../../Assets/img/introRegisterPic.svg";
import Home from "../Home/Home";
import { useNavigate } from "react-router-dom";

function Intro() {
  const navigate = useNavigate();
  const [firstPage, setFirstPage] = useState(true);
  const [secondPage, setSecondPage] = useState(false);
  const [thirdPage, setThirdPage] = useState(false);

  // اگر کاربر لاگین کرده باشه مستقیم بره صفحه اصلی
  if (localStorage.getItem("token") !== null) {
    return <Home />;
  }

  return (
    <>
      {firstPage && (
        <div className={styles.introBody}>
          <div className={styles.intro}>
            <div className={styles.introTop}>
              <img src={intro1} alt="" />
            </div>

            <div className={styles.introBottom}>
              <div className={styles.introBottomDivs}>
                <div className={styles.divYellow1}></div>
                <div className={styles.divYellow2}></div>
                <div className={styles.divYellow3}></div>
              </div>
              <p>
                !به اپلیکیشن آریانا پارس خوش اومدی
                <br />
                اینطور که معلومه میخوای مهاجرت کنی
              </p>
              <div className={styles.buttonYellowShadow}>
                <button
                  className={styles.buttonYellow}
                  onClick={() => {
                    setFirstPage(false);
                    setSecondPage(true);
                  }}
                >
                  <img src={arrow} alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {secondPage && (
        <div className={styles.introBody}>
          <div className={styles.intro}>
            <div className={styles.introTop}>
              <img src={intro2} alt="" />
            </div>

            <div className={styles.introBottom}>
              <div className={styles.introBottomDivs}>
                <div className={styles.divBlue1}></div>
                <div className={styles.divBlue2}></div>
                <div className={styles.divBlue3}></div>
              </div>
              <p>
                چه تحصیلی بخوای بری چه کاری و چه سرمایه گذاری اینجا همه فرصت ها
                برات فراهمه
                <br />
              </p>

              <div className={styles.buttonBlueShadow}>
                <button
                  className={styles.buttonBlue}
                  onClick={() => {
                    setSecondPage(false);
                    setThirdPage(true);
                  }}
                >
                  <img src={arrow} alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {thirdPage && (
        <div className={styles.introBody}>
          <div className={styles.intro}>
            <div className={styles.introTop}>
              <img src={intro3} alt="" />
            </div>

            <div className={styles.introBottom}>
              <div className={styles.introBottomDivs}>
                <div className={styles.divGreen1}></div>
                <div className={styles.divGreen2}></div>
                <div className={styles.divGreen3}></div>
              </div>
              <p>اگه فرصت مناسبتو پیدا نکردی میتونی درخواست مشاوره بدی</p>
              <div className={styles.introBtnsLogin}>
                <button
                  className={styles.loginBtn}
                  onClick={() => navigate("/login")}
                >
                  ورود <img src={login} alt="" />
                </button>
                <button
                  className={styles.registerBtn}
                  onClick={() => navigate("/register")}
                >
                  ثبت نام <img src={register} alt="" />
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Intro;